<div class="app-layout-container">

  <!-- ========== HEADER ========== -->
  <div class="header-section">
    <mat-toolbar color="primary" class="header-toolbar">
      <mat-toolbar-row>
        <span class="logo">
          <img src="assets/newimages/EcolavAthena.png" alt="ECOLAB">
        </span>
        <span class="spacer"></span>
        <span class="user-guide-download">
          <img src="assets/newimages/Downloaguide.png" alt="" (click)="downloadPDF()">
        </span>
        <span class="user-info">
          <img src="assets/newimages/HelpIcon.png" alt="" (click)="openDialog()">
        </span>
       
<span class="user-info">
  <img src="assets/newimages/ProfileIcon.png" alt="">
  <span class="user-name">
    {{ getUserName }}
  </span>
</span>

        <!-- <mat-icon>keyboard_arrow_down</mat-icon> -->
      </mat-toolbar-row>
    </mat-toolbar>
  </div>

  <!-- ========== SIDEBAR + CONTENT ========== -->
  <mat-sidenav-container class="sidenav-container">

    <!-- Sidebar -->
    <mat-sidenav
      mode="side"
      opened
      class="sidenav"
      [ngClass]="{'expanded': isExpanded}">

      <!-- Toggle Button -->
          <!-- Toggle Button -->
<div class="toggle-btn" (click)="toggleSidenav()">
  @if (!isExpanded) {
    <span>
      <img src="assets/newimages/ExpandIcon.png" alt="Expand">
    </span>
  } @else {
    <span>
      <img src="assets/newimages/Collapse.png" alt="Collapse">
    </span>
  }
</div>
      <!-- Navigation List -->
      <mat-nav-list>
       <mat-list-item class="order-item">
          <span *ngIf="!isExpanded">
            <img class="collapsed-order" src="assets/newimages/order-image.png" alt="">
          </span>
          <span *ngIf="isExpanded" class="expanded-order">
            <img src="assets/newimages/orderExpand.png" alt="">
          </span>
        </mat-list-item>

        <!-- <mat-list-item>
          <span>
            <img src="assets/newimages/SettingsIcon.png" alt="Settings">
          </span>
          <span *ngIf="isExpanded" class="nav-text">Settings</span>
        </mat-list-item> -->
      </mat-nav-list>
    </mat-sidenav>

    <!-- Projected Page Content -->
    <mat-sidenav-content class="sidenav-content">
      <ng-content></ng-content>
    </mat-sidenav-content>

  </mat-sidenav-container>

  <!-- ========== FOOTER ========== -->
  <mat-toolbar class="footer-toolbar">
    <span class="copy-right">© Ecolab {{ currentYear }}</span>
    <span class="spacer"></span>
    <span class="logo">
      <img src="assets/newimages/privacyicon.png" alt="ECOLAB">
    </span>
    <span class="spacer"></span>
    <span class="logo">
      <img src="assets/newimages/Logo.png" alt="ECOLAB" width="82px" height="16px">
    </span>
  </mat-toolbar>

</div>
